<template>
  <LayoutWidget theme="light">
    <router-view></router-view>
    
  </LayoutWidget>
</template>

<script setup>
import { onMounted } from 'vue';
import LayoutWidget from './components/LayoutWidget.vue';
import { redirectIOSHomePageToApp } from './utils/mobileAppRedirect';

onMounted(redirectIOSHomePageToApp);
</script>
